module.exports = __webpack_public_path__ + "static/media/network.8a6fa721.jpg";